import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';

import Serializer from 'umg-ember-backend/serializers/application';

export default class CollectionSerializer extends Serializer.extend(
  EmbeddedRecordsMixin,
) {}
